import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useGetAdminVirtualUsersQuery, usePostAdminVirtualLoginMutation } from '../../../api'
import { IOption } from '../../../../shared/components/forms/search-input/BpSearchInput'
import { BpSelect } from '../../../../shared/components/forms/select/BpSelect'
import { useAppSelector } from '../../../store/hooks/Redux'
import { selectUser } from '../../../store/reducers/AuthSlice'
import { useImpersonateAvailable } from '../hooks/UseImpersonateAvailable'

/** Выбор пользователя для входа под ним: только админам и в режиме имперсонации */
export const ImpersonateSelect = () => {
  const { t } = useTranslation()
  const user = useAppSelector(selectUser)
  const isAvailable = useImpersonateAvailable()

  const { data: virtualUsers } = useGetAdminVirtualUsersQuery(undefined, { skip: !isAvailable })
  const [virtualLogin] = usePostAdminVirtualLoginMutation()

  const virtualUserOptions = useMemo<IOption[]>(
    () =>
      Object.values(virtualUsers?.data?.users ?? {}).map((virtualUser) => ({
        text: virtualUser.company_name ?? '',
        value: String(virtualUser.user_id),
      })),
    [virtualUsers],
  )

  if (!isAvailable) return null

  return (
    <BpSelect
      className={'max-w-[200px]'}
      defaultValue={String(user.id)}
      fieldSize={'sm'}
      loading={!virtualUsers}
      options={virtualUserOptions}
      placeholder={t('notifications.selectUser')}
      theme={'text'}
      onChange={(e) => {
        const userId = Number(e.target.value)

        userId !== user.id &&
          virtualLogin({ userId }).then(() => {
            window.location.href = '/projects'
          })
      }}
    />
  )
}
